<template lang="html">
  <section class="contenedor-tabla" :style="styles.colorBasic">

    <div class="contenedor-opciones row-between" id="cabecera">

      <h2 class="ficha-title" :style="styles.colorBasic" v-html="$t('ficha.listado_ofertas')" v-if="$route.name == 'ofertas-practicas-tutor'"></h2>
      <h2 class="ficha-title" :style="styles.colorBasic" v-html="$t('ficha.listado_practicas')" v-else></h2>

      <div class="row-end">
        <a class="option-table column-center" v-if="!!dataSelected && dataSelected.length != 0 
        && $route.name != 'anexos'">
          <button class="show-filtros" @click="showFiltro = !showFiltro">
          </button>
           <span @click="showFiltro = !showFiltro" v-html="$t('filtro_practica.filtro_avanzado')"></span>
        </a>
        
        <a class="option-table column-center" v-if="!!dataSelected && dataSelected.length != 0">
          <i class="column row-between ais" @click="exportExcel">
            <excel></excel>
          </i>
          <span @click="exportExcel" v-html="$t('descargar')"></span>
        </a>

        <a class="option-table column-center">
          <i class="column row-between ais" @click="showColumnasSetter = !showColumnasSetter">
            <columnas></columnas>
          </i>
          <span @click="showColumnasSetter = !showColumnasSetter" v-html="$t('columnas')"></span>
          <column-setter v-if="showColumnasSetter" :columns="encabezados" @change="setColumnas"
            @cerrar="showColumnasSetter = false"></column-setter>
        </a>
      </div>
    </div>

    <template v-if="loading">
      <div class="loader" id="loader"></div>
      <p class="loader-text">CARGANDO...</p>
    </template>
     <template v-else-if="$route.name == 'anexos' && loadingFirmante">
      <div class="loader" id="loader"></div>
      <p class="loader-text">CARGANDO...</p>
    </template>
    <template v-else>
      <filtro-practicas v-if="showFiltro && $route.name != 'anexos'" :data="practicasFiltradas" ref="miFiltro"></filtro-practicas>
      <div class="scroll-table" id="contenido">
     
        <div class="contenedor-tabla" :type="$route.name" v-if="!!practicasFiltradas">

          <template >
            <div class="row-start btnFirma" id="btnFirma"
              v-show="brand.firmaMultipleAnexos && $route.name == 'anexos'  && $route.fullPath.includes('pendiente_firma') && seleccionados.length > 0">
              <a class="btn -xs" :style="styles.solidPrimary" @click="showpopup = true">{{ $t('firmar_seleccionados') }}</a>
            </div>
             <div class="row-start btnFirma"
              v-show="brand.firmaMultipleAnexos && $route.fullPath.includes('pendiente_firma')">
              <label class="container checkTodos">
                  <input type="checkbox" v-model="seleccionarTodos">
                  <span class="checkmark"></span>
              </label>
            </div>
            <v-client-table :data="practicasFiltradas" :columns="columns" :options="options" @row-click='open'>
              <span v-if="brand.firmaMultipleAnexos && $route.fullPath.includes('pendiente_firma')" slot="selector"
                slot-scope="{ row }">
                <div v-if="row.urlFirma">
                  <label class="container">
                    <input type="checkbox" v-model="seleccionados" :value="row.idPractica">
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div v-else>
                  <label class="container">
                    <input type="checkbox" disabled>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </span>

              <span class="checkbox-cell row-start" slot="checkbox" slot-scope="{ row }">

                <figure class="indicador-status" :status="row.idEstadoValidacion" :title="row.estadoValidacion"></figure>

                <template v-if="!!row">
                  <fav :data="row"></fav>
                </template>

                <loading v-else></loading>

              </span>

              <span class="action-cell row-start" slot="urlAnexo" slot-scope="{ row }">
                <div class="contenedor-data" v-if="row.urlAnexo">
                  <p class="descargar"><a class="btn -xs" :style="styles.solidPrimary" :href="row.urlAnexo"
                      target="_blank">{{ $t('descargar') }}</a></p>
                </div>
              </span>

              <span class="action-cell row-start" slot="firma" slot-scope="{ row }">
                <div class="contenedor-data" v-if="row.urlFirma">
                  <p class="descargar"><a class="btn -xs" :style="styles.solidPrimary" :href="row.urlFirma"
                      target="_blank">{{ $t('firmar') }}</a></p>
                </div>
                <div v-else
                  title="El documento estará disponible para su firma una vez haya firmado el resto de firmantes">
                  <p class="descargar"><a class="btn -xs disabled" :style="styles.solidPrimary">{{ $t('firmar') }}</a></p>
                </div>
              </span>

              <span class="action-cell row-start" slot="actions" slot-scope="{ row }">
              <router-link :to="linkBack+row.idOferta" class="to-ficha" v-if="$route.name == 'ofertas-practicas-tutor'">
                <next></next>
              </router-link>
                <router-link :to="linkBack + row.idPractica" class="to-ficha" v-else>
                  <next></next>
                </router-link>
              </span>
            </v-client-table>

          </template>

          
        </div>


        <loading v-else></loading>

      </div>
    </template>

    <confirm-popup :texto="'Se va a proceder a firmar todos los anexos seleccionados. ¿Está seguro?'"
      :titulo="'¿Desea continuar?'" :textoaceptar="'Confirmar'" :textorechazar="'Rechazar'" :loading="loadingFirmaMultiple"
      v-if="showpopup" @accept="firmarTodos" @cancel="cerrarPopupFirma">
    </confirm-popup>
  </section>
</template>

<script lang="js">

import { ClientTable, Event } from 'vue-tables-2';

import Vue from 'vue';

Vue.use(ClientTable);

import daterangepicker from 'daterangepicker';

window.moment = require('moment');

import router from '@/router';

import { mapGetters, mapActions } from 'vuex';

import columnSetter from '@/components/parts/column-setter';

import next from '@/components/parts/icons/next';
import excel from '@/components/parts/icons/excel';
import columnas from '@/components/parts/icons/columnas';

import fav from '@/components/parts/fav';

import loading from '@/components/parts/loading';
import confirmPopUp from '@/components/parts/confirm-popup';

import XLSX from 'xlsx';

import filtro from '@/components/views/filtro-practicas';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'contenedor-tabla',
  props: [],
  mounted() {
    this.setColumnas();
    window.addEventListener('resize', this.setPosition);
    window.document.getElementById('contenidoScroll').addEventListener('scroll', this.hideSearch);
  },
  methods: {
    setColumnas() {

      let alwaysActive = ['actions', 'checkbox'];

      this.encabezados = this.getEncabezados[this.lang][this.$route.name];

      // /SETTING DE LOS NOMBRE DE LAS COLUMNAS
      let columnas = (!!this.encabezados) ? Object.entries(this.encabezados) : [];

      let visibles = new Object();

      if (this.brand.firmaMultipleAnexos && this.$route.fullPath.includes('pendiente_firma')) {
        this.columns = ['selector', 'checkbox'];
        alwaysActive.push('selector');
      } else {
        this.columns = ['checkbox'];
      }

      columnas.forEach(e => {
        if (e[1].visible) {
          visibles[e[0]] = e[1].nombre;
          this.columns.push(e[0])
          this.options.columnsClasses[e[0]] = '-' + e[0]
        }
      });

      alwaysActive.forEach(e => {
        visibles[e] = '';
      })
      this.columns.push('actions');

      this.options.headings = visibles;
    },
    toggleAllChecks: function () {
      if (this.selected.length > 0) {
        this.selected = {};
      }

    },
    open: function ({ row }) {

      if (event.target.tagName == "TD") {

        if (!this.linkBack.includes("undefined")) {
          
          if (this.$route.name == 'aprobaciones') {
            router.push(this.linkBack + row.urlAcceso)
          }else if (this.$route.name == 'ofertas-practicas-tutor') {
            router.push(this.linkBack + row.idOferta)
          } else {
            router.push(this.linkBack + row.idPractica)
          }

        } else {
          if (this.$route.name == 'aprobaciones') {
            router.push(`${this.$route.meta.indexPath[this.lang]}/${row.urlAcceso}`);
          } else {
            router.push(`${this.$route.meta.indexPath[this.lang]}/${row.idPractica}`);
          }
        }
      }

      if (this.showFiltro){
        this.$refs.miFiltro.posicionarBuscador();
      }
    },
    exportExcel() {
      let data = XLSX.utils.json_to_sheet(this.listadopracticas);
      const workbook = XLSX.utils.book_new();
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // month is zero-based
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      const filename = String(`${dd}-${mm}-${yyyy} - Listado prácticas`);
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    setPosition() {
      let btnFirma = document.querySelector('#btnFirma');
      if (btnFirma) {
        let btnWidth
        if (btnFirma.offsetWidth != 0) {
          btnWidth = btnFirma.offsetWidth;
        } else {
          btnWidth = 190;
        }
        let tabla = document.querySelector('.table-responsive').children[0];
        let width = tabla.offsetWidth - btnWidth;
        let height = tabla.offsetHeight + 30;
        btnFirma.style.top = height.toString() + 'px';
        btnFirma.style.left = width.toString() + 'px';
      }
    },
    hideSearch(){
      const outside = document.getElementsByClassName('VueTables__search')[0];
      let scroll = window.document.getElementById('contenidoScroll');

      let value = 140 - scroll.scrollTop;
      outside.style.top = '-52px';

      if (value < 100) {
        outside.style.visibility = 'hidden';
      }else{
        outside.style.visibility = 'visible';
      }
    },
    ...mapActions(['toggleFavoritos', 'prepararFirmaMultipleAnexos']),
    cerrarPopupFirma() {
      if (!this.loadingFirmaMultiple) {
        this.showpopup = false;
      }
    },
    firmarTodos() {
      this.loadingFirmaMultiple = true;
      this.prepararFirmaMultipleAnexos(this.seleccionados).then(datos => {
        if (datos) {
          this.showpopup = false;
          window.open(datos.urlFirma, '_blank');
        }
      }).finally(() => {
        this.loadingFirmaMultiple = false;
      });
    }
  },
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      colors: 'basicColors',
      validaciones: 'getValidaciones',
      validacionesPorEstados: 'getValidacionesPorEstados',
      tutoradas: 'getTutoradas',
      aprobaciones: 'getAprobaciones',
      firmante: 'getFirmante',
      aprobacionesporEstados: 'getAprobacionesPorEstados',
      tutoradasPorEstados: 'getTutoradasPorEstados',
      firmantePorEstados: 'getFirmantePorEstados',
      favoritos: 'getFavoritos',
      getEncabezados: 'getEncabezados',
      textos: 'getTexts',
      loading: 'getLoading',
      loadingFirmante: 'getLoadingFirmante',
      lang: 'getLanguage',
      brand: 'getBrand',
      getServer: 'getServer',
      ofertasTutores: 'getOfertasTutores',
      filtrosData: 'getfiltrosPracticas'
    }),
    linkBack: function () {
      let status = ["pendents", "validades", "rebutjades", "pendientes", "validadas", "rechazadas", "aprobadas", "denegadas", "en-curso", "en-evaluacion", "evaluados", "pendiente_firma", "firmados", "ofertas"];
      let link = `${this.$route.meta.indexPath[this.lang]}/`;

      if (status.some(e => this.$route.params.status == e)) {
        link += this.$route.params.status + '/';
      }
      
      return link;
    },
    dataSelected: function () {
      this.setColumnas();
      let selected = new Array();
      let status = ["pendents", "validades", "rebutjades", "pendientes", "validadas", "rechazadas", "aprobadas", "denegadas", "en-curso", "en-evaluacion", "evaluados", "pendiente_firma", "firmados"];
    
      if (!!this.$route.params.status && status.some(e => this.$route.params.status == e)) {
        if (this.$route.name == 'validaciones') {
          selected = (!!this.$route.params.status) ? this.validacionesPorEstados[this.$route.params.status] : this.validaciones;
        } else if (this.$route.name == 'tutorados') {
          selected = (!!this.$route.params.status) ? this.tutoradasPorEstados[this.$route.params.status] : this.tutoradas;
        } else if (this.$route.name == 'aprobaciones') {
          selected = (!!this.$route.params.status) ? this.aprobacionesporEstados[this.$route.params.status] : this.aprobaciones;
        } else if (this.$route.name == 'anexos') {
          selected = (!!this.$route.params.status) ? this.firmantePorEstados[this.$route.params.status] : this.firmante;
        }

      } else {
        if (this.$route.name == 'validaciones') {
          selected = this.validaciones;
        } else if (this.$route.name == 'tutorados') {
          selected = this.tutoradas;
        } else if (this.$route.name == 'aprobaciones') {
          selected = this.aprobaciones;
        } else if (this.$route.name == 'anexos') {
          selected = this.firmante;
        } else if (this.$route.name == 'ofertas-practicas-tutor') {
          selected = this.ofertasTutores;
        }
      }

      (!!!selected) ? selected = [] : null;
      return selected;
    },
    listadopracticas() {
      if (!!this.dataSelected) {

        let practicas = new Array();
        if (this.$route.name == 'anexos') {
          this.dataSelected.forEach(c => {
            let practica = {
              "Id práctica": c.idPractica,
              "Nombre": c.nombreEstudiante,
              "Apellidos":  c.apellidosEstudiante,
              "ID Alumno": c.claveAlumno,
              "Email": c.emailEstudiante,
              "Curso": c.curso,
              "Código asignatura": c.codAsignatura,
              "Nombre de empresa": c.nombreEmpresa
            }

            practicas.push(practica);
          });
        } else if (this.$route.name.includes('tutorados')) {
          this.dataSelected.forEach(c => {
            let practica = {
              "Id práctica": c.idPractica,
              "Nombre": c.nombreEstudiante,
              "Apellidos":  c.apellidosEstudiante,
              "ID Alumno": c.claveAlumno,
              "Email": c.emailEstudiante,
              "Titulación": c.titulacion,
              "Tipo Creditos": c.tipoCreditos,
              "Código asignatura": c.codAsignatura,
              "Curso": c.curso,
              "Fecha Inicio": c.fechaInicio,
              "Fecha Fin": c.fechaFin,
              "Total Horas": c.totalHoras,
              "Nombre de empresa": c.nombreEmpresa,
              "Evaluación alumno": c.evaluadaPorAlumnoTexto,
              "Evaluación empresa": c.evaluadaPorTutorTexto,
              "Valoración global de la empresa": c.valoracionEmpresa
            }

            practicas.push(practica);
          });
        } else if (this.$route.name.includes('ofertas')) {
          this.dataSelected.forEach(c => {
            let practica = {
              "Id oferta": c.idOferta,
              "Nombre": c.puesto,
              "Nombre empresa":  c.nombreComercialEmpresa,
              "Fecha de publicación": c.fechaAlta,
              "Ubicación": c.localidad,
              "Número de plazas": c.numeroPlazas,
            }

            practicas.push(practica);
          });
        } else {
          this.dataSelected.forEach(c => {
            let practica = {
              "Id práctica": c.idPractica,
              "Nombre": c.nombreEstudiante,
              "Apellidos":  c.apellidosEstudiante,
              "ID Alumno": c.claveAlumno,
              "Email": c.emailEstudiante,
              "Titulación": c.titulacion,
              "Tipo Creditos": c.tipoCreditos,
              "Código asignatura": c.codAsignatura,
              "Curso": c.curso,
              "Fecha Inicio": c.fechaInicio,
              "Fecha Fin": c.fechaFin,
              "Horas al Día": c.horasDia,
              "Nº Dias Semana": c.numDiasSemana,
              "Total Horas": c.totalHoras,
              "Puesto": c.puesto,
              "Nombre de empresa": c.nombreEmpresa,
            }

            practicas.push(practica);
          });
        }

        return practicas;

      }
    },
    practicasFiltradas: function () {
    let practicas = this.dataSelected.slice();
    
    if (this.$route.name != 'anexos'){
        if (!!this.dataSelected) {
          if (this.$route.name == 'ofertas-practicas-tutor' ){
            //FILTRO POR NOMBRE OFERTA
            if (this.filtrosData.puesto) {
              practicas = practicas.filter(practica => {
              return practica.puesto.toLowerCase().includes(this.filtrosData.puesto.toLowerCase())
              });
            }

            //FILTRO POR NOMBRE EMPRESA
            if (this.filtrosData.nombreComercialEmpresa) {
              practicas = practicas.filter(practica => {
              return practica.nombreComercialEmpresa.toLowerCase().includes(this.filtrosData.nombreComercialEmpresa.toLowerCase())
              });
            }
          }else{
            //FILTRO POR TITULACIÓN
            practicas = practicas.filter(practica => {
              if (!!practica.titulacion) {
                return practica.titulacion.toLowerCase().includes(this.filtrosData.titulacion.toLowerCase())
              } else {
                return true;
              }
            });

            //FILTRO POR CODASIGNATURA
            practicas = practicas.filter(practica => {
              return practica.codAsignatura.toLowerCase().includes(this.filtrosData.codAsignatura.toLowerCase())
            });

            //FILTRO POR TIPO CREDITOS
            if (this.filtrosData.tipoPractica) {
              practicas = practicas.filter(practica => {
              return practica.tipoCreditos.toLowerCase() === (this.filtrosData.tipoPractica.toLowerCase())
              });
            }
           
            //FILTRO POR CURSO
            if (!!this.filtrosData.curso){
              practicas = practicas.filter(practica => {
                return practica.curso != null && practica.curso.includes(this.filtrosData.curso)
              });
            }

       
            //FECHA DE INICIO
            if (!!this.filtrosData.f_inicio_desde) {
              let dateInicio = new Date(this.filtrosData.f_inicio_desde).setHours(0,0,0,0);
              practicas = practicas.filter(practica => {
                let inicio = new Date(practica.fechaInicioDate).getTime();
                return (dateInicio <= inicio);
              })
            }

            //FECHA DE INICIO
            if (!!this.filtrosData.f_inicio_hasta) {
              let dateInicio = new Date(this.filtrosData.f_inicio_hasta).setHours(0,0,0,0);
              practicas = practicas.filter(practica => {
                let fin = new Date(practica.fechaInicioDate).getTime();
                return (dateInicio >= fin);
              })
            }

              //FECHA DE FIN
            if (!!this.filtrosData.f_fin_desde) {
              let dateInicio = new Date(this.filtrosData.f_fin_desde).setHours(0,0,0,0);
              practicas = practicas.filter(practica => {
                let inicio = new Date(practica.fechaFinDate).getTime();
                return (dateInicio <= inicio);
              })
            }

            //FECHA DE FIN
            if (!!this.filtrosData.f_fin_hasta) {
              let dateFin = new Date(this.filtrosData.f_fin_hasta).setHours(0,0,0,0);
              practicas = practicas.filter(practica => {
                let fin = new Date(practica.fechaFinDate).getTime();
                return (dateFin >= fin);
              })
            } 
          }
       
      }
    }
    return practicas;
    }
  },
  components: {
    'column-setter': columnSetter,
    'next': next,
    'fav': fav,
    'columnas': columnas,
    'excel': excel,
    'loading': loading,
    'confirm-popup': confirmPopUp,
    'filtro-practicas' : filtro
  },
  data() {
    return {
      seleccionarTodos: false,
      showColumnasSetter: false,
      showFiltro: false,
      selected: {},
      encabezados: {},
      columns: [],
      options: {
        skin: 'table',
        highlightMatches: true,
        headings: {},
        texts: {
          filter: "Buscar:",
          filterBy: 'Filtrar por {column}',
          count: '',
          records: 'Resultados',
          limit: "Por Página: ",
          page: "Págína:",
          noResults: "No se han encontrado resultados",
          filterPlaceholder: "Escribe para buscar",
        },
        templates: {
          fechaAlta: (h, row) => {
            return moment(row.fechaAlta).format('DD/MM/YYYY');
          },
          fechaInicioDate: (h, row) => {
            return moment(row.fechaInicioDate).format('DD/MM/YYYY');
          },
          fechaFinDate: (h, row) => {
            return moment(row.fechaFinDate).format('DD/MM/YYYY');
          }
        },
        perPage: 10,
        resizableColumns: true,
        perPageValues: [10, 20, 30, 50],
        columnsClasses: {},
        sortIcon: {
          is: 'glyphicon-sort',
          base: 'glyphicon',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
        rowClassCallback(row, $route) {
          let lastParam = window.location.pathname.split("/").pop();
          return (row.idPractica == lastParam) ? 'selected' : '';
        }
      },
      tableData: [],
      seleccionados: [],
      showpopup: false,
      loadingFirmaMultiple: false
    }
  },
  watch: {
    'seleccionados'() {
      if (document.querySelector('#btnFirma') != null) {
        this.setPosition();
      }
    },
    seleccionarTodos: function(value) {
      if (value) {
        var pendientesFirma = this.dataSelected.filter(item => item.urlFirma);
        this.seleccionados = pendientesFirma.map(item => item.idPractica);
      } else {
        this.seleccionados = [];
      }
    },
    'showFiltro'() {
      let outside = document.getElementsByClassName('VueTables__search')[0];
      
      if (!this.showFiltro){
        outside.style.top = '-52px';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ficha-title {
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
}

.toggle-todo {
  position: absolute;
  left: 10px;
  top: 47px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #d8d8d8;
  font-size: 12px;
  color: #4a4a4a;
}

.contenedor-tabla {
  width: 100%;
  min-height: 100%;
  display: inline-block;
}

.contenedor-opciones {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.option-table {
  text-transform: uppercase;
  font-size: 9px;
  text-align: center;
  padding: 0 10px;
  position: relative;
}

.column {
  width: 30px;
  height: 30px;
  position: relative;
  margin-bottom: 10px;

  svg {
    width: 40px;
  }
}

.to-ficha {
  width: 10px;
  height: 20px;
  display: inline-block;
  font-size: 0;

  svg {
    width: 10px;
    height: 20px;
  }
}


.checkbox-cell {
  min-width: 65px;
}

/* Checkbox */
.container {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container input {
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
}

.container:hover input~.checkmark {
  background-color: #ccc;
}

.container input:checked~.checkmark {
  background-color: rgb(255, 184, 28);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked~.checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 4px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.btnFirma {
  position: absolute;
  min-width: 185px;
  z-index: 1;
}

.checkTodos{
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/contenedor-tabla.vue